import "../../../../../assets/css/subscreens/customer/dashboard/apphome/nearforyou/NearForYou.css";
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, LayoutGrid } from 'lucide-react';
import axios from 'axios';
import { useServiceWorkerContext } from '../../../../../context/workercontext/WorkerContext';
import ServiceCard from "../../../../../components/customer/services/servicecards/ServiceCards";
import AppContext from "../../../../../context/AppContext";

const NearForYouFinal = () => {
  const navigate = useNavigate();
  const { setSelectedWorker } = useServiceWorkerContext();

  const {baseUrl,   baseUrlForFile} = useContext(AppContext);

  const [services, setServices] = useState([]);
  const [parallaxOffset, setParallaxOffset] = useState({ x: 0, y: 0 });

  // ── Fetch categories ──
 const fetchCategories = () => {
  const authToken = localStorage.getItem('authToken');
  axios
    .get(`${baseUrl}/customer/viewcategories`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
  .then((response) => {
  console.log("API RESPONSE:", response.data);

  setServices(response.data.categories || []);
})
    .catch((error) => {
      console.log(error);
    });
};

  useEffect(() => {
    fetchCategories();
  }, []);

  // ── Parallax effect ──
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (window.innerWidth <= 768) return;
      const { clientX, clientY } = e;
      const { innerWidth, innerHeight } = window;
      setParallaxOffset({
        x: ((clientX / innerWidth) - 0.5) * 20,
        y: ((clientY / innerHeight) - 0.5) * 20,
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  // ── Handlers ──
const handleClick = (service) => {

  console.log("CLICK CATEGORY:", service);

  navigate('/post-a-job', {
    state: {
      serviceType: service.name,
    },
  });

};

  const handleViewAll = () => navigate('/customer-category');

  // ── Sirf pehli 5 show karo ──
  const visibleServices = services.slice(0, 5);

  return (
    <section className="nfy-final-section">

      <div className="nfy-final-header">
        <h1 className="nfy-final-title">Near for You</h1>
        <button className="nfy-final-view-all" onClick={handleViewAll}>
          View all <ArrowRight size={16} />
        </button>
      </div>

      <div className="nfy-final-grid">

        {/* Pehli 5 categories */}
        {visibleServices.map((service, i) => (
          <ServiceCard
            key={service.id}
            index={i}
            onClick={handleClick}
            item={{
              id:          service.id,
              name:        service.categoryName,
              description: service.description,
image: `${baseUrlForFile}/${service.categoryImage}`,            }}
          />
        ))}

        {/* 6th card — View More (sirf tab jab 5 se zyada categories hon) */}
        {services.length > 5 && (
          <div className="nfy-card-custom nfy-viewmore-card" onClick={handleViewAll}>
            <div className="nfy-viewmore-card__inner">
              <div className="nfy-viewmore-card__icon">
                <LayoutGrid size={26} />
              </div>
              <span className="nfy-viewmore-card__label">View More</span>
            </div>
          </div>
        )}

      </div>

    </section>
  );
};

export default NearForYouFinal;